<template>
  <div class="bto-sb-widget-wrap bto-sb-matchdetails-wrap">
    <!------------------------------------- Widget Title ---------------------------------------->
    <div class="bto-sb-widget bto-sb-widget-match-title bto-sb-widget-category-dropdown">
      <!------------Compact Title-------------->
      <div class="bto-sb-match-name" :class="{ 'bto-sb-open': openEvent }">
        <div class="bto-sb-match-title-match">
          <ul class="bto-sb-breadcrumb">
            <li v-for="(tab, index) in breadcrumpTabs" :key="index">
              <router-link :to="getLink(tab.name)">{{ getName(tab.name) }}</router-link>
            </li>
          </ul>
          <h3>
            <a v-if="changeEvent" href="javascript:void(0);" class="bto-sb-widget-title-dropdown" @click.prevent="openChangeEvents()">
              {{match.name}}
              <span class="bto-sb-arrow" ></span>
            </a>
            <span v-else>
              {{match.name}}
            </span>
          </h3>
        </div>
        <div class="bto-sb-match-title-details">
          <div class="bto-sb-match-title-icons">
            <favorite-component
              v-if="showFavorites"
              :isInMatchDetails="true"
              :match="match"></favorite-component>
            <!-- <a href="javascript:void(0);"
              :title="t('Match.Statistics.Title')"
              class="bto-sb-event-statistics"></a>
            <span
              v-if="match.hasLiveStream"
              class="bto-sb-event-livestream"
              :class="{ 'bto-sb-event-time-live': matchType !== 'live' }">
              <i title="Live Stream" class="bto-app-live-stream-o"></i>
            </span> -->
          </div>
          <div class="bto-sb-time" v-if="matchType !== 'live'">
            {{ match.date }} {{ match.time }}
          </div>
          <div
            class="bto-sb-time"
            v-if="matchType === 'live'"
            :class="{ 'bto-sb-timelive': matchType === 'live' }">
            <i v-if="match.time">{{ match.time }} </i> {{ match.status }}
          </div>
        </div>
        <EventSelect
          :match="match"
          v-if="changeEvent"
          :isOpen="openEvent"
          :preMatchEvents="preMatchEvents"
          @openEvents="openChangeEvents" />
      </div>
      <!------------END Compact Title-------------->
      <div class="bto-sb-match-teams" v-if="match.matchId && showBigTitle">
        <div class="bto-sb-mb-team bto-sb-mb-team-home">
          <logo-component v-if="showTeamIcon" v-slot="{ url, reset, onLoad, loaded }" :logo-url="match.awayAtHome ? match.guestTeamIcon :match.homeTeamIcon" >
            <span class="bto-sb-mb-team-logo" v-if="url" v-show="loaded" >
              <img :src="url" alt="" @error="reset" @load="onLoad" />
            </span>
          </logo-component>
          <span class="bto-sb-mb-team-name">
            {{ match.awayAtHome ? match.guestTeam : match.homeTeam }}
          </span>
        </div>
        <div class="bto-sb-mb-score" v-if="matchType !== 'live'">
          {{ match.awayAtHome ? "@" : t("Mobile.VS") }}
        </div>
        <div class="bto-sb-mb-score bto-sb-mb-scorelive" v-if="matchType === 'live'">
          <span class="bto-sb-mb-teamscore bto-sb-mb-homescore">
            {{ match.awayAtHome ? match.score.away : match.score.home }}
          </span>
          <span class="bto-sb-mb-teamscore-sep">-</span>
          <span class="bto-sb-mb-teamscore bto-sb-mb-awayscore">
            {{ match.awayAtHome ? match.score.home : match.score.away }}
          </span>
        </div>
        <div class="bto-sb-mb-team bto-sb-mb-team-away">
          <logo-component v-if="showTeamIcon" v-slot="{ url, reset, onLoad, loaded }" :logo-url="match.awayAtHome ? match.homeTeamIcon :match.guestTeamIcon" >
            <span class="bto-sb-mb-team-logo" v-if="url" v-show="loaded">
              <img :src="url" alt="" @error="reset" @load="onLoad" />
            </span>
          </logo-component>
          <span class="bto-sb-mb-team-name">
            {{ match.awayAtHome ? match.homeTeam : match.guestTeam }}
          </span>
        </div>
      </div>
      <div
        v-if="hasLiveStream() && !livePlayerFailed"
        class="bto-sb-widget bto-sb-widget-prematch bto-sb-widget-prematch-full-view">
        <livestream-component
          v-if="hasLiveStream() && !livePlayerFailed && matchType === 'live'"
          :streamId="match.streamId || lcoMatch.streamId"
          :key="match.streamId || lcoMatch.streamId"
          :providerId="match.brokerId || lcoMatch.integrationBrokerId"
          @streamLoadError="livePlayerLoadError" />
      </div>
      <inline-message v-if="livePlayerFailed" type="info" :message="t('Mobile.LiveStreamFailed')" />
      <div
        class="bto-sb-widget"
        v-if="
          matchType === 'live' &&
          (match.isLiveMatch || liveTrackerForceEnabled) &&
          useLiveTracker &&
          match.betRadarId
        ">
        <live-tracker-component
          v-if="useLiveTracker && (!hasLiveStream() || livePlayerFailed) && match.betRadarId"
          :betRadarId="match.betRadarId"
          :tournamentId="match.tournamentId"
          :tournamentName="match.tournamentName"
          :isAwayAtHome="match.awayAtHome"/>
        <inline-message
          v-if="livePlayerFailed"
          type="info"
          :message="t('Mobile.LiveStreamFailed')" />
      </div>
    </div>
    <!------------------------------------- END Widget Title ---------------------------------------->
    <!-- Zoom soccer component-->
    <zoom-soccer-component
      v-if="match.sportId === zoomSoccerId && match.betRadarId"
      :betRadarId="match.betRadarId"
      :tournamentName="match.tournamentName"
      :isLive="match.isLiveMatch" />
    <!-- Prematch statistic component -->
    <prematch-tracker-component
      v-if="showStatistics && !match.isLiveMatch && match.betRadarId && match.feedProvider"
      :betRadarId="match.betRadarId"
      :feedProvider="match.feedProvider"
      :isAwayAtHome="match.awayAtHome" />
    <!------------------------------------- Widget Prematch ---------------------------------------->
    <div
      class="bto-sb-widget bto-sb-widget-prematch-us"
      v-if="match.matchId"
      :class="getMarketClassName()">
      <div class="bto-sb-widget-content">
        <div class="bto-sb-event-odds-nav">
          <div class="bto-sb-event-odds-nav-labels">
            <div class="bto-sb-event-odds-left">
              <div class="bto-sb-event-odds-cell">{{ t("Public.GameLines") }}</div>
            </div>
            <div class="bto-sb-event-odds-right">
              <div class="bto-sb-event-odds-cell">
                <span
                  class="bto-sb-event-marketlabel"
                  v-for="(market, index) in getMarketsName(match.sportId, match)"
                  :key="index">
                  {{ t(market.n || market.name) }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="bto-sb-event-odds-content">
          <MatchItemUs
            :item="matchLive"
            :singleMarketView="false"
            :template="''"
            :showFirstCombo="false"
            :showSecondCombo="false"
            :is3WaySport="isThreeWay(match.sportId)"
            :firstComboOddType="{}"
            :secondComboOddType="{}"
            :showMarketsInMatch="true"
            :showEventCode="false"
            :showTeamIcon="showTeamIcon"
            :showFavorites="true"
            :showStatistics="true"
            :isLive="match.isLiveMatch"
            :isInMatchDetails="true"
            :eventDescription="match.tournamentName"
            @showCombsLeg="false" />
        </div>
      </div>
    </div>
    <!------------------------------------- END Widget Prematch ---------------------------------------->

    <!------------------------------------- BOOSTED ODDS ---------------------------------------->
    <boosted-odd-widget
      v-if="match.matchId && !match.isLiveMatch"
      :showSportFilter="false"
      :showTitle="false"
      :showTeamFlags="showTeamIcon"
      :embedded="true" />
    <!------------------------------------- END BOOSTED ODDS ---------------------------------------->

    <!------------------------------------- Widget Match Nav ---------------------------------------->
    <div class="bto-sb-widget bto-sb-widget-main-nav bto-sb-widget-pills-nav" v-if="match.matchId">
      <div class="bto-sb-widget-content" ref="navBar">
        <div class="bto-sb-event-sports bto-sb-event-sports-slide">
          <div
            v-show="showLeftButton"
            class="bto-sb-event-more-sports bto-sb-event-more-sports-left">
            <a @click="sideScroll('left')"></a>
          </div>
          <ul class="markets-tabs">
            <li :class="{ 'bto-sb-main-nav-active': selectedMarket === null }">
              <a href="javascript:void(0);" title="All Markets" @click="selectMarket(null)">
                {{ t("Mobile.AllMarkets") }}
              </a>
            </li>
            <li
              v-if="hasBetBuilder"
              :class="{ 'bto-sb-main-nav-active': selectedMarket === BB_TAB_ID }">
              <a href="javascript:void(0);" @click="openBetBuilderOffer()">
                {{ t("BB.BetBuilder") }}
              </a>
            </li>
            <li
              v-for="(tab, idx) in match.tabs"
              :key="idx"
              :class="{ 'bto-sb-main-nav-active': selectedMarket === tab.id }">
              <a href="javascript:void(0);" :title="tab.name" @click="selectMarket(tab.id)">
                {{ tab.name }}
              </a>
            </li>
            <li
              :class="{ 'bto-sb-main-nav-active': selectedMarket === 'player-markets' }"
              v-if="isPlayerTabVisible">
              <a
                href="javascript:void(0);"
                :title="playerTab.name || t('Public.PlayerMarkets')"
                @click="selectMarket('player-markets')">
                {{playerTab.name || t('Public.PlayerMarkets') }}
              </a>
            </li>
            <li
              :class="{ 'bto-sb-main-nav-active': selectedMarket === 'playerOdds' }"
              v-if="playerOdds.length">
              <a href="javascript:void(0);" @click="selectMarket('playerOdds')">
                {{ t("Global.OddType.GoalScorers") }}
              </a>
            </li>
            <li
              :class="{ 'bto-sb-main-nav-active': selectedMarket === 'cashout' }"
              v-if="showCashoutTab && hasCashoutOdds">
              <a href="javascript:void(0);" @click="selectMarket('cashout')">
                {{ t("Mobile.cashout") }}
              </a>
            </li>
          </ul>
          <div
            v-show="showRightButton"
            class="bto-sb-event-more-sports bto-sb-event-more-sports-right">
            <a @click="sideScroll('right')"></a>
          </div>
        </div>
      </div>
    </div>
    <div
      class="bto-sb-widget bto-sb-widget-main-nav bto-sb-widget-title bto-support-legend"
      v-if="showLegendBar && ((showCashoutTab && hasCashoutOdds) || hasBetBuilder)">
      <span v-if="showCashoutTab && hasCashoutOdds">
        <i class="bto-app-cash"></i>
        {{ t("Public.SupporCashout") }}
      </span>
      <span v-if="hasBetBuilder">
        <i class="bto-app-betbuilder"></i>
        {{ t("Public.SupporBetBuilder") }}
      </span>
    </div>
    <!------------------------------------- END Widget Match Nav ---------------------------------------->
    <!------------------------------------- Widget Markets ---------------------------------------->
    <template v-if="selectedMarket === BB_TAB_ID">
      <inline-message
        v-if="selectedMarket === BB_TAB_ID"
        :message="t('BB.MinimumTwoSelections')"
        type="info" />
      <template v-if="selectedMarket === BB_TAB_ID && sportCastFixtureId && hasBetBuilderMarkets">
        <BetBuilderTab
          v-for="(tab, key, idx) in betBuilderTabs"
          :key="key"
          :tab="tab"
          :tabIdx="idx"
          :fixture="betBuilderFixture" />
      </template>
      <template v-if="selectedMarket === BB_TAB_ID && swishFixtureId && hasSwishBetBuilderMarkets">
        <SwishBetBuilderTab
          v-for="(tab, key, idx) in swishBetBuilderTabs.markets"
          :key="key"
          :marketsType="key"
          :tab="tab"
          :tabIdx="idx"
          :fixture="betBuilderFixture"
          :match="match"
          :getMatchDetailsExpandedMarkets="getMatchDetailsExpandedMarkets"
          :matchInfo="swishBetBuilderTabs.matchInfo" />
      </template>
    </template>
    <template v-else>
      <template
        v-for="(tab, index) in match.tabs.filter(
          (tab) =>
            selectedMarket === tab.id || selectedMarket === null || selectedMarket === 'cashout'
        )">
        <tab-market-us
          v-for="(market, idx) in tab.odds.filter(filterRegularMarkets)"
          :market="market"
          :match="match"
          :key="`${index}_${idx}`"
          :showOdds="getMatchDetailsExpandedMarkets()" />
        <!------------------------------------- END Widget Markets ---------------------------------------->
      </template>
    </template>
    <outrights-tab-market-us v-if="showOutrights" :tab="outrightMarketTab" :match="match" />
    <div
      v-if="
        playerOddsViewType === 'all' &&
        playerOdds.length &&
        (selectedMarket === 'playerOdds' || selectedMarket === null)
      "
      class="bto-sb-widget bto-sb-widget-prematch-us bto-sb-widget-markets-us bto-sb-player-market-us">
      <div class="bto-sb-widget-title bto-sb-collapsed bto-sb-show">
        <h3>{{ t("Global.OddType.GoalScorers") }}</h3>
      </div>
      <div class="bto-sb-widget-content">
        <div class="bto-sb-event-odds-nav">
          <div class="bto-sb-event-odds-nav-labels">
            <div class="bto-sb-event-odds-left">
              <!-- TODO: add translation -->
              <div class="bto-sb-event-odds-cell">Player</div>
            </div>
            <div class="bto-sb-event-odds-right">
              <div class="bto-sb-event-odds-cell">
                <span class="bto-sb-event-marketlabel">{{ t("Mobile.FirstGoalScorer") }}</span>
                <span class="bto-sb-event-marketlabel">{{ t("Mobile.AnyGoalScorer") }}</span>
                <span class="bto-sb-event-marketlabel">{{ t("Mobile.LastGoalscorer") }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="bto-sb-market-items">
          <div class="bto-sb-event-odds-content" v-for="(player, idx) in playerOdds" :key="idx">
            <div class="bto-sb-event-odds">
              <div class="bto-sb-event-odds-left">
                <div class="bto-sb-event-name">
                  <a>
                    <div class="bto-sb-event-wrap">
                      <span class="bto-sb-event-team">
                        <span class="bto-sb-event-info">
                          <span class="bto-sb-event-home">
                            {{ player.firstName }} {{ player.lastName }}
                          </span>
                          <span class="bto-sb-event-description">
                            {{ player.teamName }}
                          </span>
                        </span>
                      </span>
                    </div>
                  </a>
                </div>
              </div>
              <div class="bto-sb-event-odds-right">
                <div class="bto-sb-event-odds-cell">
                  <match-odd-component
                    :match="match"
                    :odd="{
                      marketName: player.firstName,
                      competitorId: player.competitorId,
                    }"
                    :outcome="{
                      id: `p-o-${match.matchId}-${player.competitorId}-${player.playerId}-${playerOddIds.first}`,
                      name: t('Mobile.FirstGoalScorer'),
                      originalDecimalOutcome: player.originalFirstGoalOdd,
                      playerOddId: playerOddIds.first,
                      playerId: player.playerId,
                      suspended: player.suspended,
                    }" />
                  <match-odd-component
                    :match="match"
                    :odd="{
                      marketName: player.firstName,
                      competitorId: player.competitorId,
                    }"
                    :outcome="{
                      id: `p-o-${match.matchId}-${player.competitorId}-${player.playerId}-${playerOddIds.any}`,
                      name: t('Mobile.AnyGoalScorer'),
                      originalDecimalOutcome: player.originalAnyGoalOdd,
                      playerOddId: playerOddIds.any,
                      playerId: player.playerId,
                      suspended: player.suspended,
                    }" />
                  <match-odd-component
                    :match="match"
                    :odd="{
                      marketName: player.firstName,
                      competitorId: player.competitorId,
                    }"
                    :outcome="{
                      id: `p-o-${match.matchId}-${player.competitorId}-${player.playerId}-${playerOddIds.last}`,
                      name: t('Mobile.LastGoalscorer'),
                      originalDecimalOutcome: player.originalLastGoalOdd,
                      playerOddId: playerOddIds.last,
                      playerId: player.playerId,
                      suspended: player.suspended,
                    }" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bto-sb-widget-footer">
          <!-- TODO implement show more logic -->
        </div>
      </div>
    </div>
    <empty-state
      v-if="!match.matchId"
      :message="emptyStateStatusMessage"
      :icon-class="emptyStateClass" />
      <template v-if="selectedMarket === null || selectedMarket === 'player-markets'" >
        <player-markets-component :match="match" :groups="playerTab.groups || []" />
        <player-markets-component :match="match" :groups="(match.playerMarketsTab && match.playerMarketsTab.groups) || []" />
      </template>
  </div>
</template>

<script>
  import MatchDetailsWidget from './widget-match-details';
  import MatchItemUs from '../../common/match-item/match-item-us.vue';
  import { MARKET_TYPE_IDS } from '../../../models/enums/market-const';
  import store from "../../../store";
  import TabMarketUs from './common/component-tab-market-us';
  import FavoriteComponent from '../../shared/favorite-component';
  import LiveMatchModel from '../live-now/models/live-match-model';
  import { urlFriendlyParam } from '@bto-services/utils';
  import BoostedOddWidget from '@bto-widgets/boosted-odd/src/web';
  import OutrightsTabMarketUs from './common/outrights-tab-market-us.vue';
  import PrematchTrackerComponent from '../../common/match/prematch-tracker-component';
  import CompactMatchTitleService from './common/compact-match-title-service';
  import { LiveWorker } from "../../../workers";
  import ZoomSoccerComponent from '../../common/match/zoom-soccer-component';
  import { ZOOM_SOCCER_ID } from 'bto-models/match/zoom';

  export default {
    name: 'MatchDetailsWidgetUs',
    extends: MatchDetailsWidget,
    components: {
      MatchItemUs,
      TabMarketUs,
      FavoriteComponent,
      BoostedOddWidget,
      OutrightsTabMarketUs,
      PrematchTrackerComponent,
      ZoomSoccerComponent,
    },
    data() {
      return {
        showTeamIcon: APP_SETTINGS.matchDetails.showTeamIcon,
        matchDetailsExpandedMarkets: (+APP_SETTINGS.matchDetails.matchDetailsExpandedMarkets) || 0,
        showLegendBar: APP_SETTINGS.matchDetails.showLegendBar,
        sportSelectorMoveDistance: 16,
        showLeftButton: false,
        showRightButton: false,
        windowResize: null,
        useLiveTracker: APP_SETTINGS.liveTracker ? APP_SETTINGS.liveTracker.useLiveTracker : false,
        breadcrumpTabs: CompactMatchTitleService.getContents(),
        showBigTitle: APP_SETTINGS.matchDetails.showBigTitle,
        showFavorites: APP_SETTINGS.category.showFavorites,
        liveMatches: [],
        zoomSoccerId: ZOOM_SOCCER_ID,
      };
    },
    created() {
      window.addEventListener("resize", this.showHideScrollButtons);
      LiveWorker.postMessage({ ev: 'liveall', resp: {} });
      LiveWorker.addEventListener('message', this.getAllLiveMatches);
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.showHideScrollButtons);
      LiveWorker.removeEventListener('message', this.getAllLiveMatches);
      clearTimeout(this.windowResize);
    },
    computed: {
      matchLive() {
        // let matchLive = (this.match.isLiveMatch && (window.btoSignalRAvailibility || []).find(a => (+a.brid) === this.match.betRadarId)) || {};
        let matchesLive = (this.match.isLiveMatch && this.liveMatches.find(lm => lm[this.match.betRadarId])) || {};
        const matchLive = matchesLive[this.match.betRadarId] || new LiveMatchModel({}, APP_SETTINGS);
        return this.match.isLiveMatch ? matchLive : this.match;
      },
      marketCropMap() {
        // Temporal object to count how many markets have been rendered,
        // This resets to 0 on every tab change so we can start fresh
        return {
          [`cm${this.selectedMarket}`]: 0,
        };
      },
      hasBetBuilderMarkets() {
        return Object.keys(this.betBuilderTabs).length > 0
      },
      hasSwishBetBuilderMarkets() {
        return Object.keys(this.swishBetBuilderTabs).length > 0;
      },
      hasBetBuilder() {
        return this.sportCastFixtureId || this.swishFixtureId;
      },
      tabsCount() {
        let sum = 0;
        if (this.match && this.match.tabs) {
          sum += this.match.tabs.length;
        }
        if (this.hasBetBuilder) {
          sum += 1;
        }
        if (this.playerTab.groups) {
          sum += this.playerTab.groups.length;
        }
        if (this.playerOdds) {
          sum += this.playerOdds.length;
        }
        if (this.showCashoutTab && this.hasCashoutOdds) {
          sum += 1;
        }

        return sum;
      },
      isPlayerTabVisible() {
        return (this.playerTab.groups && this.playerTab.groups.length) ||
          (this.match.playerMarketsTab && this.match.playerMarketsTab.groups && this.match.playerMarketsTab.groups.length);
      }
    },
    methods: {
      getAllLiveMatches(msg) {
        if (msg.data.type === 'liveall') {
          this.liveMatches = Object.values(msg.data.data.lm);
        }
      },
      filterRegularMarkets(market) {
        if (this.selectedMarket === 'cashout' && market.cashout && !market.isDuplicateMarket) {
          return this.isItDuplicateMarket(market);
        }
        if (this.selectedMarket === null && !market.isDuplicateMarket) {
          return this.isItDuplicateMarket(market);
        }
        if (!(this.selectedMarket === null || this.selectedMarket === 'cashout')) {
          return true;
        }
        return false;
      },
      isThreeWay(sportId) {
        let getSportType = store.getters.getSportType;
        return getSportType(sportId) === MARKET_TYPE_IDS.THREE_WAY;
      },
      getMatchDetailsExpandedMarkets() {
        if (!this.matchDetailsExpandedMarkets) {
          return false;
        }
        if (this.marketCropMap[`cm${this.selectedMarket}`] >= this.matchDetailsExpandedMarkets) {
          return false;
        }
        this.marketCropMap[`cm${this.selectedMarket}`] += 1;

        return true;
      },
      getMarketClassName() {
        const numberOfMarkets = this.getMarketsName(this.match.sportId, this.match).length || 1;
        if (numberOfMarkets > 2) {
          return '';
        }
        return numberOfMarkets === 2 ? 'bto-sb-widget-us-two-mar' : 'bto-sb-widget-us-one-mar';
      },
      getMarketsName(sportId, item) {
        if (this.isThreeWay(sportId)) {
          return [
            { n: 'Public.Home' },
            { n: 'Public.Tie' },
            { n: 'Public.Away' },
          ];
        }
        if (this.matchType === 'live' && item.isLiveMatch) {
          return this.matchLive.marketsInfo;
        }
        return store.getters.getSportMarketsUs(item.sportId);
      },
      getTournamentLink(match) {
        let routeParams = {};
        const sportName = match.isLiveMatch ? store.getters.getSportName(match.sportId) : match.sportName;
        routeParams.fixtureIds = `${match.tournamentId || '-'}`;
        routeParams.tournament = urlFriendlyParam(match.tournamentName);
        routeParams.sport = urlFriendlyParam(sportName || '');
        if (match.isLiveMatch) {
          routeParams.tabIndex = 0;
        }
        return { name: 'seoTournament', params: routeParams };
      },
      getCategoryLink(match) {
        let routeParams = {};
        const sportName = match.isLiveMatch ? store.getters.getSportName(match.sportId) : match.sportName;
        routeParams.categoryId = `${match.categoryId || '-'}`;
        routeParams.category = urlFriendlyParam(match.categoryName);
        routeParams.sport = urlFriendlyParam(sportName || '');
        if (match.isLiveMatch) {
          routeParams.tabIndex = 0;
        }
        return { name: 'seoCategory', params: routeParams };
      },
      /**
       *  horizontal scroll on click
       */
      sideScroll(direction) {
        let element = this.$refs.navBar;
        let stepWidth = element.offsetWidth / 3;
        let directionStep = direction === "right" ? element.scrollLeft + stepWidth : element.scrollLeft - stepWidth;
        this.scrollTo(element, Math.ceil(directionStep), direction);
      },
      /**
       * Animate scrolling
       * @param element
       * @param to
       * @param direction
       */
      scrollTo(element, to, direction) {
        if (to < 0) {
          to = 0;
        }
        const maxScrollLeft = element.scrollWidth - element.offsetWidth;
        if (to >= maxScrollLeft) {
          to = maxScrollLeft;
        }
        let reqAnim = 0;
        const tick = () => {
          const currentLeft = Math.ceil(element.scrollLeft);
          const newLeft = direction === "right" ?
            currentLeft + this.sportSelectorMoveDistance :
            currentLeft - this.sportSelectorMoveDistance;
          element.scrollLeft = newLeft;
          if ((direction === "right" && newLeft < to) || (direction === "left" && newLeft > to)) {
            reqAnim = requestAnimationFrame(tick);
          } else {
            this.showHideScrollButtons();
            cancelAnimationFrame(reqAnim);
          }
        };
        reqAnim = requestAnimationFrame(tick);
      },
      showHideScrollButtons() {
        if (!this.$refs.navBar) {
          this.showLeftButton = false;
          this.showRightButton = false;
          return;
        }
        if (this.$refs.navBar.scrollLeft > 0) {
          this.showLeftButton = true;
        } else {
          this.showLeftButton = false;
        }

        if (Math.ceil(this.$refs.navBar.scrollLeft) + 1 >= Math.ceil(this.$refs.navBar.scrollWidth - this.$refs.navBar.clientWidth)) {
          this.showRightButton = false;
        } else {
          this.showRightButton = true;
        }
      },
      getName(name) {
        switch (name) {
          case 'sport':
            return store.getters.getSportName(this.match.sportId);
          case 'category':
            return this.match.categoryName;
          case 'tournament':
            return this.match.tournamentName;
        }
        return '';
      },
      getLink(name) {
        const sportId = this.match.sportId;
        const sportName = urlFriendlyParam(store.getters.getSportName(this.match.sportId));
        const categoryId = `${this.match.categoryId || '-'}`;
        const categoryName = urlFriendlyParam(this.match.categoryName);
        const tournamentId = `${this.match.tournamentId || '-'}`;
        const tournamentName = urlFriendlyParam(this.match.tournamentName);
        switch (name) {
          case 'sport':
            return { name: 'seoSport', params: { sportId, sportName } };
          case 'category':
            return { name: 'seoCategory', params: { category: categoryName, sport: sportName, categoryId } };
          case 'tournament':
            return { name: 'seoTournament', params: { fixtureIds: tournamentId, tournament: tournamentName, sport: sportName } };
        }
      },
      isItDuplicateMarket(market) {
        const tabIndex = this.match.tabs.findIndex(x => x.id === market.tabId);
        if (tabIndex === 0 || this.matchTypeProp === "live") {
          return true;
        }
        const idsForCheck = [...this.match.tabs].splice(0, tabIndex)
          .reduce((acc, val) => acc.concat([...val.odds]),[])
          .map(x => ({ [x.marketId]: x.extraId }));
        for (const id of idsForCheck) {
          const key = Object.keys(id);
          if (+key[0] === market.marketId) {
            const value = Object.values(id);
            return !(value[0] === market.extraId);
          }
        }
        return true;
      },
    },
    watch: {
      tabsCount() {
        this.$nextTick(this.showHideScrollButtons);
      },
    },
  };
</script>